import React from "react";
import Logo from '../../../assets/logo.svg';
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";

const SignUp = () =>(
    <div className="container-fluid auth-layout">
        <div className="row auth-shell">
            <LeftSection />

            <div className="col-12 col-lg-6 auth-panel auth-panel--form">
                <div className="row auth-form-shell">
                    <div className="col-12">
                        <div className="container-fluid auth-brand-row">
                            <a className="navbar-brand auth-brand-link" href="./home">
                                <img src={Logo} alt="Capital Trends" />
                            </a>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="container-fluid auth-form-container">
                            <h2 className="login-header">Sign up</h2>
                            
                            <RightSection />

                            <div className="text-center pt-5">
                                <span>Already have an account?</span> 
                                <a href="/sign-in" className="btn btn-link primary-links">Log in</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)   

export default SignUp;
